import '@iconfu/svg-inject/dist/svg-inject.js';

export default class Icons {
    private static inject($xi: JQuery, name: string): void {
        const url = '/theme/images/icons/' + name + '.svg';

        const $img = $(`<img src="${url}" onload="SVGInject(this)">`);

        $img.appendTo($xi);
    }

    public static discover($parent?: JQuery): void {
        $('.xi:not(.xi--loaded)', $parent).each((ix, el) => {
            const $xi = $(el);

            const css: string = $xi.prop('class');
            const m = css.match(/xi-([\w\d\-]+)/);

            if (m.length >= 2) {
                $xi.addClass('xi--loaded');

                const name = m[1];

                this.inject($xi, name);
            }
        });
    }
}
